import { createRouter, createWebHistory } from 'vue-router'
import { i18n } from '@/plugins/i18n'
import LayoutExterno from '@/layouts/LayoutExterno.vue'
import LayoutInterno from '@/layouts/LayoutInterno.vue'
import LayoutRegistro from '@/layouts/LayoutRegistro.vue'
import LayoutExternoBackground from '@/layouts/LayoutExternoBackground.vue'
import LayoutErro from '@/layouts/LayoutErro.vue'
import LayoutMobileErro from '@/layouts/LayoutMobileErro.vue'
import { useAutenticacaoStore, useUsuarioStore, useEmpresaStore } from '@/stores'
import { useNavigationStore } from '@/stores/navigation'

const idiomasSuportados = ['pt', 'en', 'es']
const idiomaDefault = 'pt'

const router = createRouter({
    history: createWebHistory(),
    routes: [
        {
            path: '/',
            redirect: `/${idiomaDefault}/dashboard`,
        },
        {
            path: '/:locale',
            children: [
                {
                    path: '',
                    component: LayoutExterno,
                    children: [
                        {
                            path: 'login',
                            name: 'Login',
                            component: () => import('@/views/Login.vue'),
                            meta: {
                                titleKey: 'paginas.login',
                            },
                        },
                        {
                            path: 'change_password',
                            name: 'ChangePassword',
                            component: () => import('@/views/ChangePassword.vue'),
                            meta: {
                                titleKey: 'paginas.recuperarSenha',
                            },
                        },

                        {
                            path: 'new_password/:token',
                            name: 'NewPassword',
                            component: () => import('@/views/NewPassword.vue'),
                            meta: {
                                titleKey: 'paginas.novaSenha',
                            },
                            props: true,
                        },
                    ],
                },
                {
                    path: '',
                    component: LayoutRegistro,
                    children: [
                        {
                            path: 'register_company',
                            name: 'RegisterCompany',
                            component: () => import('@/views/RegisterCompany.vue'),
                            meta: {
                                titleKey: 'paginas.registrarEmpresa',
                            },
                        },
                        {
                            path: 'register_user/:id?',
                            name: 'register_user',
                            component: () => import('@/views/RegisterUser.vue'),
                            meta: {
                                titleKey: 'paginas.registrarUsuario',
                            },
                        },
                    ],
                },
                {
                    path: '',
                    component: LayoutInterno,
                    meta: { requerAutenticacao: true },
                    children: [
                        {
                            path: 'dashboard',
                            name: 'Dashboard',
                            component: () => import('@/views/Dashboard.vue'),
                            meta: {
                                titleKey: 'paginas.dashboard',
                                requerAutenticacao: true,
                                reuse: false,
                            },
                        },
                        {
                            path: 'dashboard/profile',
                            name: 'Profile',
                            component: () => import('@/views/Profile.vue'),
                            meta: {
                                titleKey: 'profile.title_part1',
                                requerAutenticacao: true,
                            },
                        },
                        {
                            path: 'dashboard/config',
                            name: 'Config',
                            component: () => import('@/views/Config.vue'),
                            meta: {
                                titleKey: 'profile.title_part1',
                                requerAutenticacao: true,
                            },
                        },
                        {
                            path: 'dashboard/travel',
                            name: 'travel',
                            component: () => import('@/views/Travel/TravelDiary.vue'),
                            meta: {
                                titleKey: 'dashboard.config.travels.configbtn_title.title1',
                                requerAutenticacao: true,
                            },
                        },

                        {
                            path: 'dashboard/travel-approvals',
                            name: 'travel-approvals',
                            component: () => import('@/views/Travel/TravelApprover.vue'),
                            meta: {
                                titleKey: 'dashboard.config.travels.configbtn_title.title2',
                                requerAutenticacao: true,
                            },
                        },

                        {
                            path: 'dashboard/travel/new',
                            name: 'TravelFormPageNew',
                            component: () => import('@/views/Travel/TravelFormPage.vue'),
                            props: {
                                isEditMode: false,
                            },
                            meta: {
                                titleKey: 'dashboard.config.travels.configbtn_title.title1',
                                requerAutenticacao: true,
                            },
                        },

                        {
                            path: 'dashboard/travel/edit/:companyTravelId',
                            name: 'TravelFormPageEdit',
                            component: () => import('@/views/Travel/TravelFormPage.vue'),
                            props: (route) => ({
                                companyTravelId: route.params.companyTravelId,
                                isEditMode: true,
                            }),
                            meta: {
                                titleKey: 'dashboard.config.travels.configbtn_title.title1',
                                requerAutenticacao: true,
                            },
                        },

                        {
                            path: 'dashboard/travel-approvals/view/:companyTravelId',
                            name: 'TravelFormPageApproverView',
                            component: () => import('@/views/Travel/TravelFormPage.vue'),
                            props: (route) => ({
                                companyTravelId: route.params.companyTravelId,
                                isEditMode: true,
                                isApproverMode: true,
                            }),
                            meta: {
                                titleKey: 'dashboard.config.travels.configbtn_title.title2',
                                requerAutenticacao: true,
                            },
                        },

                        {
                            path: 'dashboard/config/company',
                            name: 'Company',
                            component: () => import('@/views/Company.vue'),
                            meta: {
                                titleKey: 'dashboard.config.companies.title_part1',
                                requerAutenticacao: true,
                            },
                        },
                        {
                            path: 'dashboard/config/company/cost-center/:companyId?',
                            name: 'Centro-de-custo',
                            component: () => import('@/views/Centro-de-custo/Centro-de-custo.vue'),
                            meta: {
                                titleKey: '',
                                requerAutenticacao: true,
                            },
                        },
                        {
                            path: 'dashboard/config/company/projects/:companyId?',
                            name: 'Project',
                            component: () => import('@/views/Project/Project.vue'),
                            meta: {
                                titleKey: '',
                                requerAutenticacao: true,
                            },
                        },

                        {
                            path: 'dashboard/config/company/:id',
                            name: 'EditAdminCompany',
                            component: () =>
                                import('@/views/EditAdminCompany/EditAdminCompany.vue'),
                            props: true,
                            meta: {
                                titleKey: '',
                                requerAutenticacao: true,
                                admin: true,
                            },
                        },
                        {
                            path: 'dashboard/config/users',
                            name: 'Users',
                            component: () => import('@/views/Users/Users.vue'),
                            meta: {
                                titleKey: '',
                                requerAutenticacao: true,
                            },
                        },
                        {
                            path: 'dashboard/financial-control/payments',
                            name: 'FinancialControl',
                            component: () =>
                                import('@/views/Financial-control/FinancialControl.vue'),
                            meta: {
                                titleKey: '',
                                requerAutenticacao: true,
                            },
                        },
                        {
                            path: 'dashboard/financial-control/approvals',
                            name: 'FinancialControlApprover',
                            component: () =>
                                import('@/views/Financial-control/FinancialControl.vue'),
                            meta: {
                                titleKey: '',
                                requerAutenticacao: true,
                                role: 'approver',
                            },
                        },
                        {
                            path: 'dashboard/financial-control/payer',
                            name: 'FinancialControlPayer',
                            component: () =>
                                import('@/views/Financial-control/FinancialControl.vue'),
                            meta: {
                                titleKey: '',
                                requerAutenticacao: true,
                                role: 'payer',
                            },
                        },
                        {
                            path: 'dashboard/financial-control/myreleases/new',
                            name: 'MyReleasesNew',
                            component: () => import('@/views/Financial-control/MyReleases.vue'),
                            props: {
                                isEditMode: false,
                                paymentId: null,
                            },
                            meta: {
                                titleKey: '',
                                requerAutenticacao: true,
                            },
                        },
                        {
                            path: 'dashboard/financial-control/myreleases/edit/:paymentId',
                            name: 'MyReleasesEdit',
                            component: () => import('@/views/Financial-control/MyReleases.vue'),
                            props: (route) => ({
                                paymentId: route.params.paymentId,
                                isEditMode: true,
                            }),
                            meta: {
                                titleKey: 'nav_menu.financial-control',
                                requerAutenticacao: true,
                            },
                        },
                        {
                            path: 'dashboard/financial-control/myreleases/view_approve/:paymentId',
                            name: 'MyReleasesApproveView',
                            component: () => import('@/views/Financial-control/MyReleases.vue'),
                            props: (route) => ({
                                paymentId: route.params.paymentId,
                                isEditMode: true,
                                isApproveView: true,
                            }),
                            meta: {
                                titleKey: 'nav_menu.financial-control-approver',
                            },
                        },
                        {
                            path: 'dashboard/financial-control/myreleases/view_pay/:paymentId',
                            name: 'MyReleasesPayerView',
                            component: () => import('@/views/Financial-control/MyReleases.vue'),
                            props: (route) => ({
                                paymentId: route.params.paymentId,
                                isEditMode: true,
                                isPayerView: true,
                            }),
                            meta: {
                                titleKey: 'nav_menu.financial-control-payer',
                                requerAutenticacao: true,
                            },
                        },
                        {
                            path: 'dashboard/events',
                            name: 'Eventos',
                            component: () => import('@/views/Eventos/Event.vue'),
                            meta: {
                                titleKey: 'nav_menu.events',
                                requerAutenticacao: true,
                            },
                        },
                        {
                            path: 'dashboard/events/new',
                            name: 'NovoEvento',
                            component: () => import('@/views/Eventos/EventFormPage.vue'),
                            meta: {
                                titleKey: 'dashboard.config.events.form.title_new',
                                requerAutenticacao: true,
                            },
                        },
                        {
                            path: 'dashboard/events/edit/:eventId',
                            name: 'EditarEvento',
                            component: () => import('@/views/Eventos/EventFormPage.vue'),
                            props: true,
                            meta: {
                                titleKey: 'dashboard.config.events.form.title_edit',
                                requerAutenticacao: true,
                            },
                        },
                        {
                            path: 'dashboard/bobinas-gerenciar',
                            name: 'BobinasGerenciar',
                            component: () => import('@/views/Bobinas/BobinasGerenciar.vue'),
                            meta: { titleKey: 'Gerenciar Bobinas', requerAutenticacao: true },
                        },
                        {
                            path: 'dashboard/bobinas-consulta',
                            name: 'BobinasConsulta',
                            component: () => import('@/views/Bobinas/BobinasConsulta.vue'),
                            meta: { titleKey: 'Consulta Bobinas', requerAutenticacao: true },
                        },
                        {
                            path: 'dashboard/estoque-gerenciar',
                            name: 'EstoqueGerenciar',
                            component: () => import('@/views/Bobinas/EstoqueGerenciar.vue'),
                            meta: { titleKey: 'Gerenciar Estoque', requerAutenticacao: true },
                        },
                        {
                            path: 'dashboard/config/external-config', // Caminho novo
                            name: 'ExternalConfig',
                            component: () => import('@/views/ExternalConfig.vue'),
                            meta: {
                                titleKey: 'dashboard.config.external.title', // Crie essa chave no i18n
                                requerAutenticacao: true,
                            },
                        },
                    ],
                },
                {
                    path: '',
                    component: LayoutErro,
                    children: [
                        {
                            path: 'error-403',
                            name: 'Error403',
                            component: () => import('@/views/Error403.vue'),
                            meta: {
                                titleKey: 'paginas.pagina_error.403.title',
                            },
                        },
                        {
                            path: '/:locale/:catchAll(.*)*',
                            name: 'Error404',
                            component: () => import('@/views/Error404.vue'),
                            meta: {
                                titleKey: 'paginas.pagina_error.404.title',
                            },
                        },
                        // {
                        //     path: 'mobile-error',
                        //     name: 'MobileError',
                        //     component: () => import('@/views/mobile-error.vue'),
                        //     meta: {
                        //       titleKey: 'paginas.mobile.title',
                        //       isMobilePage: true
                        //     },
                        //   },
                    ],
                },
                {
                    path: '',
                    component: LayoutExternoBackground,
                    children: [
                        {
                            path: 'access-new-company/:token',
                            name: 'AccessNewCompany',
                            component: () => import('@/views/AccessNewCompany.vue'),
                            props: true,
                            meta: {
                                titleKey: 'paginas.accessNewCompany.title',
                            },
                        },
                    ],
                },
                // {
                //     path: '', // Precisa ter um path base se não for o único filho
                //     component: LayoutMobileErro, // <<< Layout SÓ para mobile-error
                //     children: [
                //         {
                //             path: 'mobile-error',
                //             name: 'MobileError',
                //             component: () => import('@/views/mobile-error.vue'),
                //             meta: {
                //                 titleKey: 'paginas.pagina_error.mobile.title'
                //             },
                //         },
                //     ]
                // },
            ],
        },
    ],
})

router.beforeEach(async (to, from, next) => {
    const autenticacaoStore = useAutenticacaoStore()
    const usuarioStore = useUsuarioStore()
    const empresaStore = useEmpresaStore()
    const idiomaParametro = to.params.locale
    const rotaRequerAutenticacao = to.matched.some((record) => record.meta.requerAutenticacao)
    const idiomaFinal = idiomaParametro || idiomaDefault
    const navigationStore = useNavigationStore()

    if (from.name === 'Users' && to.name === 'Company') {
        navigationStore.setCameFromUsers(true)
    } else if (from.name !== 'Company' || (to.name !== 'Company' && to.name !== 'EditAdminCompany')) {
        navigationStore.setCameFromUsers(false)
    }

    if (autenticacaoStore.usuarioLogado) {
        try {
            const tokenRefreshed = await autenticacaoStore.verificarEAtualizarToken()

            if (!tokenRefreshed) {
                console.log('Token refresh failed, logging out...')
                autenticacaoStore.encerrarSessao()
                next({
                    path: `/${idiomaFinal}/login`,
                    query: { redirect: to.fullPath }
                })
                return
            }
        } catch (error) {
            console.error('Error refreshing token:', error)
            autenticacaoStore.encerrarSessao()
            next({
                path: `/${idiomaFinal}/login`,
                query: { redirect: to.fullPath }
            })
            return
        }
    }

    if (autenticacaoStore.usuarioLogado) {
        const idiomaPreferidoCompleto = usuarioStore.getLang()
        const idiomaPreferidoCurto = (idiomaPreferidoCompleto || idiomaDefault).substring(0, 2)

        if (idiomaParametro && idiomaParametro !== idiomaPreferidoCurto) {
            const novoCaminho = to.fullPath.replace(
                `/${idiomaParametro}`,
                `/${idiomaPreferidoCurto}`,
            )
            return next(novoCaminho)
        }
    }

    if (!idiomasSuportados.includes(idiomaFinal)) {
        const caminhoCorrigido = to.fullPath.substring(to.path.indexOf('/', 1))
        return next(`/${idiomaDefault}${caminhoCorrigido}`)
    }

    i18n.global.locale.value = idiomaFinal

    if (empresaStore.isAdmin === false && to.name === 'EditAdminCompany') {
        return next(`/${idiomaFinal}/error-403`)
    }

    // const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    //     navigator.userAgent,
    // )
    // const forceDesktop = localStorage.getItem('forceDesktop') === 'true'

    // if (
    //     isMobile &&
    //     !forceDesktop &&
    //     to.name !== 'MobileError' &&
    //     !to.path.includes('/mobile-error')
    // ) {
    //     return next(`/${idiomaFinal}/mobile-error`)
    // }

    if (autenticacaoStore.usuarioLogado && to.name === 'Login') {
        return next(`/${idiomaFinal}/dashboard`)
    }
    if (rotaRequerAutenticacao && autenticacaoStore.usuarioLogado) {
        const permissions = empresaStore.empresaAtual?.access || []
        const role = empresaStore.empresaAtual?.system_role || ''
        const isSuperOrAdm = ['super', 'adm'].includes(role)
        const isSuperUser = ['super'].includes(role)
        const isFinancialRole = role === 'financial'

        const hasAccess = (module, action) =>
            permissions.some((p) => p.mod_name === module && p.action_name === action)
        const hasPaymentAccess = (action) =>
            permissions.some(
                (p) => ['financial', 'payment'].includes(p.mod_name) && p.action_name === action,
            )
        const canRequest =
            isSuperOrAdm || hasAccess('travel', 'requester') || hasAccess('travel', 'approver')
        const canApprove = isSuperOrAdm || hasAccess('travel', 'approver')
        const requesterRoutes = ['travel', 'TravelFormPageNew', 'TravelFormPageEdit']
        if (requesterRoutes.includes(to.name) && !canRequest) {
            return next(`/${idiomaFinal}/error-403`)
        }

        const approverRoutes = ['travel-approvals', 'TravelFormPageApproverView']
        if (approverRoutes.includes(to.name) && !canApprove) {
            return next(`/${idiomaFinal}/error-403`)
        }

        /* ---------------------------------- */
        /* 🔹 Seção: Financial-control permissions       */
        /* ---------------------------------- */
        const canPay = isSuperOrAdm || isFinancialRole || hasPaymentAccess('payer')
        const canFinApprove = isSuperOrAdm || hasPaymentAccess('approver')
        const finRequesterRoutes = ['FinancialControl', 'MyReleasesNew', 'MyReleasesEdit']
        const finApproverRoutes = ['FinancialControlApprover']
        const finPayerRoutes = ['FinancialControlPayer']
        if (
            finRequesterRoutes.includes(to.name) &&
            !(isSuperOrAdm || hasPaymentAccess('requester') || canFinApprove)
        ) {
            return next(`/${idiomaFinal}/error-403`)
        }
        if (finApproverRoutes.includes(to.name) && !canFinApprove) {
            return next(`/${idiomaFinal}/error-403`)
        }
        if (finPayerRoutes.includes(to.name) && !canPay) {
            return next(`/${idiomaFinal}/error-403`)
        }
    }

    if (rotaRequerAutenticacao && !autenticacaoStore.usuarioLogado) {
        return next({
            path: `/${idiomaFinal}/login`,
            query: { redirect: to.fullPath },
        })
    }

    next()
})

router.afterEach((to) => {
    const tituloTraduzido = to.meta.titleKey ? i18n.global.t(to.meta.titleKey) : ''
    const titulo = tituloTraduzido ? `Process To Use | ${tituloTraduzido}` : 'Process To Use'
    document.title = titulo
})

export default router
